export const durationOptions = [
    { label: '1 month', value: 2678400000 },
    { label: '3 month', value: 7776000000 },
    { label: '6 month', value: 15638400000 },
];
